export default __webpack_public_path__ + "static/media/bg_jresearch.c064f2cb.png";